module.exports = __webpack_public_path__ + "static/img/07.3829cbe.svg";


//////////////////
// WEBPACK FOOTER
// ./src/apps/aquest/tutorial/07.svg
// module id = YZUQ
// module chunks = 13